<template>
  <div class="hpanel" id="AiChatManagerPanel">
    <div class="panel-heading" @click="showHide" style="cursor: pointer">
      AI Service - <span class="label label-warning"> <i>Beta</i></span>
      <div class="pull-right text-right">
        <button type="button" class="btn btn-info btn-outline btn-xs showhide">
          <i class="fa fa-chevron-up"></i>
        </button>
      </div>
      <span class="dropdown">
              <button class="btn btn-xs btn-info btn-outline" id="preset-query-ai" type="button" style=""
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <span class="hidden-xs hidden-sm">Extract and Summarize</span>
              </button>
              <ul class="dropdown-menu dropdown-menu-left text-center" data-target="preset-query-ai" aria-labelledby="preset-query-ai">
                <template v-if="promptExamples && promptExamples.length !== 0">
                  <li  class="li-managerHistory" v-for="(query, key) in promptExamples" :key="key">
                    <a :title="query.title" @click="addQueryPrompt(query.prompt, isChecked)">{{query.title}}</a>
                  </li>
                </template>
                <li v-else style="font-style: italic">
                  <a>no prompt performed yet</a>
                </li>
              </ul>
            </span>
    </div>
    <div class="panel-body">
      <form v-on:submit="executePrompt" class="form-horizontal" action="#" method="post" id="timestamp_file_form">
        <div class="form-group">
          <label for="content" class="required">Prompt</label>
          <div class="btn-group" style="float: right; margin-left: -20px">
            <span class="dropdown">
              <button class="btn btn-xs btn-info btn-outline dropdown" id="history-search" type="button" style=""
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" @click="getPromptHistory">
                <span class="hidden-xs hidden-sm">history</span> <i class="fa fa-history"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-right text-center" aria-labelledby="history-search">
                <template v-if="promptHistory && promptHistory.length !== 0">
                  <li  class="li-managerHistory" v-for="(query, key) in promptHistory" :key="key">
                    <a :title="query.prompt" @click="addQueryPrompt(query.prompt)">{{query.prompt}}</a>
                  </li>
                </template>
                <li v-else style="font-style: italic">
                  <a>no prompt performed yet</a>
                </li>
                <li role="separator" class="divider"></li>
                <li class="text-center">
                  View complete prompt history
                </li>
              </ul>
            </span>
            <span v-if="query && (listType === 'author' || listType === 'patents')"  >
              <button class="btn btn-xs btn-info btn-outline" type="button" @click="getAllFile">
              <span class="hidden-xs hidden-sm">Import Results </span> <i class="glyphicon glyphicon-import"></i>
            </button>
            </span>
          </div>
          <div >
            <textarea id="content" v-model="prompt" class="form-control" maxlength="20000" rows="7"  required></textarea>
            <div> {{ caracteresRestants }} caractères restants</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 text-center">
            <button type="reset" @click="clearPrompt" class="btn btn-default">Reset</button>
          </div>
          <div class="col-xs-6 text-center">
            <vue-ladda  type="submit" :disabled="!prompt || isSubmitDisabled" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="executePrompt"> Execute</vue-ladda>
          </div>
        </div>

        <div class="form-group" v-if="promptResult">
          <div class="row text-right">
            <div  class="btn-group pull-right document-action open">
              <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" id="dropdownSaveAiManager"  style="margin-left: -120px " class="btn btn-sm btn-info dropdown-toggle"> Save to Biblio </button>
              <ul class="dropdown-menu dropdownCopyBox" aria-labelledby="dropdownSaveAiManager" style="z-index: 999999; min-width: 250px" >
                <template v-if="biblioBoxes.length">
                  <div class="dropdownCopyBoxList">
                    <li style="width: 100%; padding: 5px 5px" > Add to existing Box :</li>
                    <li v-for="box in biblioBoxes" :key="box.key" style="width: 100%; padding: 5px 5px"><a href="#" @click="onClick('saveTo',$event)" class="li-copyToBox text-info" :data-targetBox="box.name">{{box.name}} </a></li>
                  </div>
                </template>
                <li role="separator" class="divider"></li>
                <li style="width: 100%; padding: 5px 5px" ><a href="#" @click="addKeyword" style="color:#3498db"> <i class="fa fa-plus"></i>  Add  to new box ... </a></li>
              </ul>
            </div>
          </div>
          <label for="content" class="required">Result</label>
          <textarea id="AiChatResult" v-model="promptResult" class="form-control" rows="7" ></textarea>
        </div>
      </form>
    </div>
  </div>
</template>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0;
}
.dropdownCopyBoxList{
  max-height: 370px;
  overflow: hidden;
  overflow-y: scroll;
  padding-left: 20px;
}

.li-copyToBox {
  display: block;
  width: 80%;
  margin-left: 10px;
  padding: 2px 5px;
}

.li-managerHistory a {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.li-copyToBox:hover {
  background-color: #f5f5f5;
}
</style>
<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['listIdSelected', 'searchResult', 'biblio', 'listType', 'query'],
  name: 'AiChatManagerBox',
  data () {
    return {
      boxOpen: true,
      prompt: '',
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      promptResult: null,
      promptHistory: [],
      aichatComment: '',
      promptExamples: [
        { title: 'Problems to be solved', prompt: '[%prompt_pb_su%] \n \n' },
        { title: 'Solutions investigated', prompt: '[%prompt_pb_se%] \n \n' },
        { title: 'Means and tools used', prompt: '[%prompt_pb_in%] \n \n' },
        {title: 'Results obtained', prompt: '[%prompt_pb_es%] \n \n'},
        {title: 'Future research', prompt: '[%prompt_pb_fr%] \n \n'},
        {title: 'Industries and applications', prompt: '[%prompt_pb_ia%] \n \n'}
      ],
      isChecked: true
    }
  },
  computed: {
    biblioBoxes: function () {
      let content = this.biblio && this.biblio.content ? JSON.parse(this.biblio.content) : {}
      let boxes = []
      Object.values(content).forEach((box) => {
        boxes.push({key: box.key, name: box.name})
      })
      boxes.sort(function (boxe1, boxe2) {
        if (boxe1.name.toUpperCase() < boxe2.name.toUpperCase()) return -1
        if (boxe1.name.toUpperCase() > boxe2.name.toUpperCase()) return 1
        return 0
      })
      return boxes
    },
    caracteresRestants: function () {
      return 20000 - this.prompt.length
    },
    isSubmitDisabled: function () {
      return this.prompt.length > 20000
    }
  },
  methods: {
    onClick: function (action, event) {
      switch (action) {
        case 'saveTo':
          if (this.promptResult && this.prompt) {
            this.addAiChatToBiblio(this.promptResult, event.target.dataset.targetbox, this.prompt)
          }
      }
      event.stopPropagation()
      event.preventDefault()
    },
    showHide: function (event) {
      if (event !== null) {
        event.preventDefault()
      }

      let hpanel = $(this.$el).closest('div.hpanel')
      let iconUp = $(this.$el).find('.fa-chevron-up')
      let iconDown = $(this.$el).find('.fa-chevron-down')
      let body = hpanel.find('div.panel-body:first')

      if (typeof iconUp !== 'undefined' && iconUp.length !== 0) {
        iconUp.toggleClass('fa-chevron-down').toggleClass('fa-chevron-up')
        this.boxOpen = false
      } else if (typeof iconDown !== 'undefined' && iconDown.length !== 0) {
        iconDown.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        this.boxOpen = true
      }

      body.slideToggle(this.collapseSpeed)
      hpanel.toggleClass('').toggleClass('panel-collapse')

      localStorage.setItem('AichatManagerBoxOpen', this.boxOpen)
    },
    executePrompt: function (event) {
      if (event) event.preventDefault()
      this.submit.loading = true
      this.promptResult = null
      this.axios.post('/search/chatai/prompt', {prompt: this.prompt})
        .then((response) => {
          if (response.data) {
            let resp = response.data.aichat
            if (resp) {
              this.promptResult = resp
              this.savePrompt(this.listIdSelected, this.promptResult)
            }
          }
          this.submit.loading = false
        })
        .catch((_error) => {
          this.$notify({
            type: 'warning',
            title: 'Error with AI execution query please edit or try again',
            placement: 'bottom-right'
          })
          this.submit.loading = false
        })
    },
    getPromptHistory: function () {
      this.axios.get('search/historyAiManager?limit=10').then((response) => {
        this.promptHistory = response.data
      }).catch((error) => {

      })
    },
    savePrompt: function (listId = null, ai_answer = null) {
      if (this.prompt) {
        this.axios.post('/search/historyAiManager/save', {prompt: this.prompt, listId: listId, ai_chat_answer: ai_answer})
          .then((response) => {
            if (response.data) {
              let resp = response.data.prompt
              if (resp) {
                this.promptHistory = resp
              }
            }
          })
          .catch((_error) => {
            this.$notify({
              type: 'warning',
              title: 'Error with when save prompt history',
              placement: 'bottom-right'
            })
            this.submit.loading = false
          })
        this.getPromptHistory()
      }
    },
    addQueryPrompt: function (prompt, importData = null) {
      event.stopPropagation()
      event.preventDefault()
      if (!this.boxOpen) {
        this.showHide(null)
      }
      if (prompt) {
        this.prompt = prompt
      }
      if (importData) {
        this.getAllFile()
        this.executePrompt()
      }
    },
    getAllFile: function () {
      const documents = this.searchResult.authors.slice(0, 25)
      let result = ''
      if (documents) {
        documents.flatMap((author) => author.topDocument)
          .filter((doc) => doc && doc.title && doc.abstract)
          .forEach((doc) => {
            result += 'Title : ' + doc.title + '\n' + 'Abstract : ' + doc.abstract + '\n \n'
          })
      }
      this.prompt += result.replace(/<[^>]+>/g, '').slice(0, 19000)
    },
    addAiChatToBiblio: function (promptResult, keywordId, prompt) {
      this.aichatComment = promptResult + '\n'
      this.$eventHub.$emit('addAiChatCommentToBiblio', {'aichat': this.aichatComment, 'keyId': keywordId})
    },
    addKeyword: function (e) {
      if (this.promptResult && this.prompt) {
        this.showModalAddKeyword(this.prompt, this.promptResult)
        e.preventDefault()
        e.stopPropagation()
      }
    },
    showModalAddKeyword: function (prompt, promptResult) {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.showTexteBiblio = 'boxWithComment'
        $('#modalAddKeyword').modal('show')
        this.aichatComment = promptResult + '\n'
        this.$eventHub.$emit('addKwdWithComment', this.aichatComment)
        this.$eventHub.$emit('showTexte', this.showTexteBiblio)
      }
    },
    clearPrompt: function () {
      this.prompt = ''
      this.promptResult = ''
    }
  },
  beforeMount () {
    let boxOpen = localStorage.getItem('AichatManagerBoxOpen')
    this.boxOpen = (boxOpen === null ? true : boxOpen === 'true')
    this.getPromptHistory()
  },
  mounted () {
    if (this.boxOpen === false) {
      this.showHide(null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AiChatManagerBox/AiChatManagerBox.vue